// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const MiningRewards = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="m10.21 6.55-6.606 6.577 1.287 1.288 6.607-6.578m1.625-1.63 1.001-.984a.91.91 0 1 0-1.277-1.298l-1.012.995m.703.512c1.987 1.987 2.068 4.303 1.63 6.34 0 0-1.035-2.506-3.25-4.721s-4.72-3.25-4.72-3.25c2.037-.438 4.352-.357 6.34 1.63Z"
    />
  </svg>
);
const ForwardRef = forwardRef(MiningRewards);
export default ForwardRef;
